export const environment = {
  production: false,
  msalConfig: {
    auth: {
        clientId: "7b9f5426-cb84-43c1-8ffa-bd4855064c26"
    }
},
apiConfig: {  
    scopes: ["https://dispmail.onmicrosoft.com/api/demo.read"],
    uri: "https://dev-portalenotifichesinistri.gruppohera.it/api/"
    // uri: "https://localhost:7171/api/" 
    // uri: "https://asv-dispmailes-weu-ts-002.azurewebsites.net/api/"  
},
b2cPolicies: {
    names: {
        signUpSignIn: "B2C_1_dispmailes-weu-ts-001",
        resetPassword: "B2C_1_resetdispmailes-weu-ts-001",
        editProfile: "B2C_1_profiledispmailes-weu-ts-001"  
    },
    authorities: {
         signUpSignIn: {
            authority: 'https://dispmail.b2clogin.com/dispmail.onmicrosoft.com/B2C_1_dispmailes-weu-ts-001'
        },
        resetPassword: {
            authority: 'https://dispmail.b2clogin.com/dispmail.onmicrosoft.com/B2C_1_resetdispmailes-weu-ts-001'
        },
        editProfile: {
            authority: "https://dispmail.b2clogin.com/dispmail.onmicrosoft.com/B2C_1_profiledispmailes-weu-ts-001"
        }
    },
    authorityDomain: "dispmail.b2clogin.com"
},
/*dataStorage : {
  urlBlob: "https://dlsdispmailesweuts001.blob.core.windows.net",
  container: "sinistriesterni"
},*/
  // fixed setting -> equals both in dev and prod
  roles: {
    richiedenteInterno: {
      id: 1,
      name: 'richiedenteInterno',
      display_name: 'Richiedente Interno'
    },
    richiedenteEsterno: {
      id: 2,
      name: 'richiedenteEsterno',
      display_name: 'Richiedente Esterno'
    },
    ufficio: {
      id: 3,
      name: 'ufficio',
      display_name: 'Ufficio'
    },
    admin: {
      id: 4,
      name: 'admin',
      display_name: 'admin'
    }
  },
  tipoSinistro: {
     esterno: { name: "esterno", displayName: "esterno"},
     allRisk:  { name:"internoAllRisk", displayName: "All Risk"},
     rcAuto:  { name:"internoRcAuto", displayName: "Rc Auto"},
     infortunio:  { name:"internoInfortunio", displayName: "Infortunio"},
     kasko:  { name:"internoKasko", displayName: "Kasko"},
     sinistroAttivo:  { name:"sinistroAttivo", displayName: "Sinistro Attivo"}
  },
  uffici: {
    AAA: {
      name:'AAA - Servizi Assicurativi'
     /// displayName: 'Uffici Assicurativi e Protocollo '
    },
    DclsRischi: {
      name:'DCLS - Risk Management & Assicurazioni'
      ///displayName: 'DCLS Risk Management ed Assicurazioni'
    },
    DclsAssicurazioni: {
      name:'DCLS - Assicurazioni'
      //displayName: 'DCLS Assicurazioni'
    }
  },
  standard_router: {
    richiedenteInterno: 'richiedenteInterno',
    richiedenteEsterno: 'richiedenteEsterno',
    ufficio: 'ufficio',
    admin: 'admin'
  },
  stati: {
    richiedente: {
      Bozza: "Bozza",
      RichiesteIntegrazioni: "Richieste Integrazioni",
      Inviato: "Inviato",
      Rifiutato: "Rifiutato",
      AttesaOfferta: "Attesa offerta sottoscritta",
      InPagamento: "In pagamento",
      Chiuso: "Chiuso"
    },
    ufficio: {
      //vuoto quando stato richiedente è bozza
      //utente vede inviato per tutti gli altri, tranne che per richieste integrazioni dove lui deve agire, prima di inviare di nuovo
      Nuovo: "Nuovo",
      Assegnato: "Assegnato",
      PresoInCarico: "Preso in Carico",
      RichiesteIntegrazioni: "Richieste Integrazioni",
      DaMigrare: "Da Migrare",
      ErroreMigrazione: "Errore Migrazione",
      Migrato: "Migrato",
      MigratoRichiesteIntegrazioni: "Migrato – Richieste integrazioni",
      MigratoAttesaOfferta: "Migrato – Attesa offerta sottoscritta",
      MigratoInPagamento: "Migrato - In pagamento",
      Inoltrato: "Inoltrato",
      Rifiutato: "Rifiutato",
      Lavorato: "Lavorato",
      Chiuso: "Chiuso"
    }
  },
  costanti: {
    comuneNonMappato: "*** Comune d'Italia non mappato",
    provinciaNonMappata: "TUTTI",
    servizioNonNoto: "* Non noto",
    societaNonNota: "* Non nota",
    importiSceltaKasko: {
      minore1500: 'Minore o uguale a 1.500 € IVA esclusa',
      maggiore1500: 'Maggiore di 1.500 € IVA esclusa',
      nonNoto: 'Importo non noto'
    }
  }

}